package com.wintermar.inspection.util.global_navigation

import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.asSharedFlow

class GlobalNavigationBusImpl : GlobalNavigationBus {
    private val _events = MutableSharedFlow<NavigationEvent>()
    override val events = _events.asSharedFlow()

    override suspend fun emit(event: NavigationEvent) {
        _events.emit(event)
    }
}
